// extracted by mini-css-extract-plugin
module.exports = {"box":"_6cf4","itemBtn":"_3eda","active":"_5046","itemText":"_9f86"};